import { render, staticRenderFns } from "./ViewRequestAllAttachments.vue?vue&type=template&id=6c1257b8&"
import script from "./ViewRequestAllAttachments.vue?vue&type=script&lang=js&"
export * from "./ViewRequestAllAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports